import PropTypes from 'prop-types';
import React from 'react';

import * as ST from './styled';

export const Advantage = ({ item }) => {
    return (
        <ST.Advantage>
            <ST.AdvantageImageWrap>
                <ST.AdvantageImg src={item.imgSrc} alt='icon' height='106'/>
            </ST.AdvantageImageWrap>
            <ST.AdvantageDescription>
                <ST.AdvantageTitle>{item.name}</ST.AdvantageTitle>
                <ST.AdvantageText>{item.desc}</ST.AdvantageText>
            </ST.AdvantageDescription>
        </ST.Advantage>
    );
};

Advantage.propTypes = {
    item: PropTypes.object.isRequired,
};
